import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  InputBase,
  Box,
  Button,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import ColorData from "../CstmTheme/ColorData";
import ImgPath from "../../Constants/Imgs";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../Constants/RouteUrls";
import { useSelector } from "react-redux";
import { UserInitialStateType } from "DataTypes/Redux";
import LanguageSelector from "Components/commonComponents/LanguageSelector";
import React from "react";
import DesktopNav from "Components/commonComponents/DesktopNav ";
import MenuList from "Components/commonComponents/MenuList";
import { Admin_Number } from "Utils/Common";
import MobileDrawer from "Components/commonComponents/HederDrawer";
import dayjs from "dayjs";

// Navigation handler function
export const handleNavigation = (item: string) => {
  switch (item) {
    case "Explore TPLF":
      window.location.href = "/third-party-litigation-funding-support.html";
      break;
    case "Explore Online Mediation":
      window.location.href = "/mediation-online-dispute-resolution.html";
      break;
    case "Talk to our Expert Lawyer":
      window.location.href = "/online-legal-consultation.html";
      break;
    case "Register Private Limited Company":
      window.location.href = "/register-private-limited-company.html";
      break;
    case "Register LLP":
      window.location.href = "/register-llp.html";
      break;
    case "Register Sole Propritorship":
      window.location.href = "/register-sole-propritorship.html";
      break;
    case "Protect Your Business":
      window.location.href = "/protect-your-business.html";
      break;
    case "Register Copyright":
      window.location.href = "/register-copyright.html";
      break;
    case "Register Trademark":
      window.location.href = "/register-trademark.html";
      break;
    case "Register Nidhi Company":
      window.location.href = "/register-nidhi-comany.html";
      break;
    case "Register One Person Company":
      window.location.href = "/register-one-person-company-online.html";
      break;
    case "Get Your Dedicated Legal Counsel":
      window.location.href = "/legal-manager.html";
      break;
    case "Register Your Patent":
      window.location.href = "/register-patent-online.html";
      break;
    case "Online CA Consultation":
      window.location.href = "/online-ca-consultation.html";
      break;
    case "Online CS Consultation":
      window.location.href = "/chartered-secretary-cs.html";
      break;
    case "Online Legal Consultation":
      window.location.href = "/online-legal-consultation.html";
      break;
    case "GST Filling Online":
      window.location.href = "/gst-filling-online.html";
      break;
    case "GST Registration Online":
      window.location.href = "/gst-registration-online.html";
      break;
    // Add more cases as needed for other navigation items
    default:
      console.log(`Navigation for ${item} not implemented yet`);
  }
};
const Header = () => {
  const token = localStorage.getItem("token");
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [expandedItems, setExpandedItems] = React.useState<{
    [key: string]: boolean;
  }>({});

  const currentDateTime = dayjs().format("D MMM, YYYY / h:mmA");

  const handleDrawerClick = (event: any) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (event: any) => {
    if (isMobile) {
      setDrawerOpen(true);
    }
    // Remove TypeScript type
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleExpandClick = (itemLabel: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemLabel]: !prev[itemLabel],
    }));
  };

  // Navigation items from DesktopNav
  const navItems = [
    {
      label: "TPLF",
      submenu: ["Explore TPLF"],
    },
    {
      label: "Online Mediation",
      submenu: ["Explore Online Mediation"],
    },
    {
      label: "Call the Expert",
      submenu: ["Talk to our Expert Lawyer"],
    },
    {
      label: "Setup Business",
      submenu: [
        "Register Private Limited Company",
        "Register LLP",
        "Register Sole Propritorship",
        "Protect Your Business",
        "Register Copyright",
        "Register Trademark",
        "Register Nidhi Company",
        "Register One Person Company",
        "Get Your Dedicated Legal Counsel",
        "Register Your Patent",
      ],
    },
    {
      label: "Tax & Compliance",
      submenu: [
        "Online CA Consultation",
        "Online CS Consultation",
        "Online Legal Consultation",
        "GST Filling Online",
        "GST Registration Online",
      ],
    },
    {
      label: "Drafting & Documentation",
      submenu: ["Coming Soon"],
    },
    {
      label: "Other Service",
      submenu: ["Coming Soon"],
    },
    {
      label: "AU Services",
      submenu: ["Coming Soon"],
    },
  ];

  return (
    <Box
      sx={{
        position: "sticky",
        // position: "fixed",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      {/* Top Bar */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: ColorData.primary.main, // Your theme color
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            minHeight: "none !important",
          }}
        >
          <Grid
            className="test1"
            width={"100%"}
            container
            alignItems="center"
            justifyContent={"space-between"}
            spacing={2}
          >
            {/* Left Side: Call Info */}
            <Grid size={{ xs: 6, md: 4, lg: 4 }}>
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    mr: 1,
                    borderRadius: "50%",
                    border: "1px solid white", // white border
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PhoneIcon sx={{ fontSize: "14px" }} /> {/* icon 14px */}
                </Box>
                <Typography
                  color="background.default"
                  sx={{ fontSize: "14px" }}
                >
                  Call Us&nbsp;${Admin_Number}
                </Typography>
              </Box>
            </Grid>

            {/* Center: Search Box */}
            {!isMobile && (
              <Grid
                size={{ md: 4, lg: 4 }}
                display="flex"
                justifyContent="center"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    px: 1,
                    width: "18.125rem",
                    maxWidth: 500,
                  }}
                >
                  <SearchIcon sx={{ color: ColorData.primary.main }} />
                  <InputBase placeholder="Search..." sx={{ ml: 1, flex: 1 }} />
                </Box>
              </Grid>
            )}

            {/* Right Side */}
            <Grid size={{ xs: 6, md: 4, lg: 4 }}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                gap={2}
                flexWrap="nowrap"
              >
                {!isMobile && (
                  <>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      {currentDateTime}
                    </Typography>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Download App
                    </Typography>

                    <LanguageSelector />
                  </>
                )}
                {token ? (
                  <Button
                    startIcon={<PersonIcon />}
                    sx={{ color: "#fff", textTransform: "none" }}
                    onClick={() => navigate("/dashboard")}
                  >
                    {myInfo.firstname}
                  </Button>
                ) : (
                  <Button
                    startIcon={<PersonIcon />}
                    sx={{ color: "#fff", textTransform: "none" }}
                    onClick={() => navigate(RouteUrls.login)}
                  >
                    Login
                  </Button>
                )}

                <IconButton onClick={handleDrawerClick} sx={{ color: "#fff" }}>
                  <MenuIcon />
                </IconButton>
                <MenuList
                  menuAnchorEl={menuAnchorEl}
                  handleMenuClose={handleMenuClose}
                />
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {/* Bottom Header / Logo + Menu */}
      <AppBar
        position="static"
        color="transparent"
        elevation={1}
        sx={{
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          backgroundColor: "#fff",
          color: "#000",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar className="TEst">
          <Box
            component="img"
            src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
            alt="Logo"
            sx={{
               width: { xs: "150px", sm: "200px", md: "100px" },
              height: { xs: "60px", sm: "80px", md: "83px" },
              objectFit: "contain",
              cursor: "pointer",
              filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
            onClick={() => navigate("/")}
          />
          <Box
            sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}
          >
            {!isMobile && (
              <DesktopNav navItems={navItems} onNavigate={handleNavigation} />
            )}
            {isMobile && (
              <IconButton
                onClick={handleMenuClick}
                sx={{ color: ColorData.text.primary }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <MobileDrawer
        open={drawerOpen}
        onClose={toggleDrawer}
        navItems={navItems}
        expandedItems={expandedItems}
        onExpandClick={handleExpandClick}
        onNavigate={handleNavigation}
      />
    </Box>
  );
};

export default Header;
